import { capitalDesignTokens, createTypedSxStyles } from "@opengov/capital-mui-theme";

const { semanticColors } = capitalDesignTokens;

export const styles = createTypedSxStyles({
  container: {
    marginTop: "16px",
  },
  nameContainer: {
    marginTop: "16px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  budgetName: {
    fontSize: "14px",
    color: semanticColors.foreground.primary,
  },
  proposalName: {
    alignSelf: "center",
  },
  moreButton: {
    background: "transparent",
    padding: 0,
    border: "none",
    boxShadow: "none",
  },
  loadingSpinner: {
    marginTop: "96px",
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "16px",
  },
  budgetRemoved: {
    margin: "32px 16px 16px",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
  },
  buttonOptions: {
    display: "flex",
    flexDirection: "row",
    gap: "8px",
  },
  budgetDeleted: {
    display: "flex",
    alignItems: "center",
  },
  statusWarning: {
    color: semanticColors.foreground.errorLarge,
    marginLeft: "8px",
    width: "16px",
    height: "16px",
  },
});
